import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { ScoreRecipientRegDto } from 'src/app/core/dtos/dto';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { RegistrationManagementService } from 'src/app/core/services/registration-management.service';
import { RegistrationService } from 'src/app/core/services/registration.service';

@Component({
  selector: 'app-receiving-institutions',
  templateUrl: './receiving-institutions.component.html',
  styleUrls: ['./receiving-institutions.component.scss']
})
export class ReceivingInstitutionsComponent implements OnInit, OnDestroy {
  testInfoSubscription: Subscription;
  receivingInstitutionsSubscription: Subscription;
  regId: number;
  institutions: ScoreRecipientRegDto[];

  constructor(
    private confighelper: ConfigHelper,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private registrationService: RegistrationService,
    private toastService: HotToastService,
    private registrationManagementService: RegistrationManagementService
  ) {
  }

  ngOnInit(): void {
    this.regId = Number(this.activeRoute.snapshot.params.regId);
    const brandId = this.confighelper.getBrandId();
    if (!this.regId) {
      this.router.navigate(['my-account']);
    }
    else {
      this.checkTestInfo();
    }
  }

  checkTestInfo() {
    this.testInfoSubscription = this.registrationService.getTestInfo(this.regId)
      .subscribe(result => {
        if (result.content.isCancelledOrRefunded) {
          this.router.navigate(['my-account']);
        }
        else {
          this.getReceivingInstitutions();
        }
      },
        () => {
          this.toastService.warning("There is no receiving institution for the requested test");
        });
  }

  getReceivingInstitutions() {
    this.receivingInstitutionsSubscription = this.registrationManagementService.getReceivingInstitutions(this.regId)
      .subscribe(
        result => {
          this.institutions = result.content;
        },
        () => {
          this.toastService.warning("Unable to load receiving institutions");
        }
      );
  }

  ngOnDestroy() {
    this.testInfoSubscription?.unsubscribe();
    this.receivingInstitutionsSubscription?.unsubscribe();
  }

}
